import Drawer from "@mui/material/Drawer";
import { usePopupContext } from "../../contexts/PopupContext/context";
import { Box } from "../../UI/Box";
import { Divider } from "../../UI/Divider";
import { PlacementWorksheetNotMatchedSection } from "./PlacementWorksheetNotMatchedSection";
import { PlacementWorksheetUplacedGroupsSection } from "./PlacementWorksheetUplacedGroupsSection";
import { usePlacementWorksheetContext } from "../../contexts/PlacementWorksheetContext";
import { BOTTOM_POPUP_HEIGHT } from "../PWSelectedResidentBottomPopup/PWSelectedResidentBottomPopup";
import { SearchInput } from "./SearchInput";
import { Typography } from "../../UI/Typography";


interface IProps {
  width?: string | number;
}

export const PlacementWorksheetRightPopup: React.FC<IProps> = ({ width }) => {
  const { isRightOpen, selectedResidents } = usePopupContext();
  const { l3Id } = usePlacementWorksheetContext();

  if (!l3Id) return null;

  return (
    <Drawer
      open={isRightOpen}
      elevation={3}
      variant="persistent"
      anchor="right"
      sx={{
        width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width,
        },
      }}
    >
      <Box pt={11} px={1} pb={!!selectedResidents?.length ? BOTTOM_POPUP_HEIGHT : 0}>
        <Box px={1} pt={2} pb={1}>
          <Typography gutterBottom variant="h5" fontWeight={600}>
            Unplaced
          </Typography>
          <SearchInput />
        </Box>
        <PlacementWorksheetUplacedGroupsSection />
        <Divider />
        <PlacementWorksheetNotMatchedSection />
      </Box>
    </Drawer>
  );
};
